import type {
    GetContactEnrichment_contactEnrichment as ContactEnrichment,
    GetAccountEnrichment_accountEnrichment as EnrichmentField,
} from 'nutshell-graphql-types';

import type {AdditionalFields} from '../review-enrichment-data-modal/review-enrichment-data-modal';

// This function creates a combined aditionalFields object
export function formatData(data?: ContactEnrichment | null): {
    mainFields: null | Array<EnrichmentField>;
    additionalFields: AdditionalFields;
} {
    if (!data) {
        return {
            mainFields: null,
            additionalFields: {
                socialFields: null,
                companyFields: null,
            },
        };
    }

    return {
        mainFields: data.baseFields && data.baseFields.length > 0 ? data.baseFields : null,
        additionalFields: {
            socialFields:
                data.socialFields && data.socialFields.length > 0 ? data.socialFields : null,
            companyFields:
                data.companyFields && data.companyFields.length > 0 ? data.companyFields : null,
        },
    };
}

export function getNewMainFields(
    mainFields?: Array<EnrichmentField> | null
): Array<EnrichmentField> | null | undefined {
    if (!mainFields) {
        return null;
    }

    return mainFields.filter((field) => field.isNew);
}

export function getNewAdditionalFields(additionalFields: AdditionalFields): AdditionalFields {
    if (!additionalFields) {
        return {
            socialFields: null,
            companyFields: null,
        };
    }

    const filteredAdditionalFields = {
        socialFields: [],
        companyFields: [],
    } as const;
    if (additionalFields.socialFields) {
        // @ts-expect-error
        filteredAdditionalFields.socialFields = additionalFields.socialFields.filter(
            (field) => field.isNew
        );
    }
    if (additionalFields.companyFields) {
        // @ts-expect-error
        filteredAdditionalFields.companyFields = additionalFields.companyFields.filter(
            (field) => field.isNew
        );
    }

    // @ts-expect-error
    return filteredAdditionalFields;
}

export function shouldShowData(
    mainFields: Array<EnrichmentField> | null | undefined,
    additionalFields: AdditionalFields
): boolean {
    const newMainFields = getNewMainFields(mainFields);
    const newAdditionalFields = getNewAdditionalFields(additionalFields);

    return Boolean(
        (newMainFields && newMainFields.length > 0) ||
            (newAdditionalFields.socialFields && newAdditionalFields.socialFields.length > 0) ||
            (newAdditionalFields.companyFields && newAdditionalFields.companyFields.length > 0)
    );
}
